$easyreels_labeler_name $mol_labeler
	title @ \Name
	content /
		<= value \name
